/* eslint-disable import/no-unresolved */
import plusWhiteSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/plus-white.svg';
import plusGraySvg from '!raw-loader!svgo-loader!../../assets/svg/UI/plus-gray.svg';
import dismissSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/dismiss.svg';
import redoWhiteSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/redo-white.svg';
import checkmarkBigWhiteSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/checkmark-big-white.svg';
import publishWhiteSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/publish-white.svg';
import undoWhiteSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/undo-white.svg';
import shiftOEWhiteSvg from '!raw-loader!svgo-loader!../../assets/svg/Icons/16/shift-oe-white.svg';
import shiftOEGraySvg from '!raw-loader!svgo-loader!../../assets/svg/Icons/16/shift-oe-gray.svg';
import groupsGray32Svg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/groups-gray.svg';
import locationGray32Svg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/location-gray.svg';
import positionGray32Svg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/position-gray.svg';
import tagsGray32Svg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/tag-gray.svg';
import timeGray32Svg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/time-gray.svg';
import eventsGray32Svg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/events-gray.svg';
import uiLocationGraySvg from '!raw-loader!svgo-loader!../../assets/svg/UI/location-gray.svg';
import uiEmployeeGraySvg from '!raw-loader!svgo-loader!../../assets/svg/UI/employee-gray.svg';
import uiStatusGraySvg from '!raw-loader!svgo-loader!../../assets/svg/UI/status-gray.svg';
import positionGraySvg from '!raw-loader!svgo-loader!../../assets/svg/UI/position-gray.svg';
import dayPartSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/day-part.svg';
import exclamationSvg from '!raw-loader!svgo-loader!../../assets/svg/Icons/16/exclamation.svg';
import archivedConversationsSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/archived-conversations.svg';
import msgEditSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/msg-edit.svg';
import msgTrashSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/msg-trash.svg';
import arrowRightSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/arrow-right.svg';
import stateSvg from '!raw-loader!svgo-loader!../../assets/svg/Icons/32/state.svg';
import editSvg from '!raw-loader!svgo-loader!../../assets/svg/UI/edit-gray.svg';

/* eslint-enable import/no-unresolved */
import angular from 'angular'; // eslint-disable-line import/order

const SVG_MAP = {
  /* eslint-disable key-spacing */
  'svg/UI/plus-white.svg': plusWhiteSvg,
  'svg/UI/plus-gray.svg': plusGraySvg,
  'svg/UI/dismiss.svg': dismissSvg,
  'svg/UI/redo-white.svg': redoWhiteSvg,
  'svg/UI/checkmark-big-white.svg': checkmarkBigWhiteSvg,
  'svg/UI/publish-white.svg': publishWhiteSvg,
  'svg/UI/undo-white.svg': undoWhiteSvg,
  'svg/Icons/16/shift-oe-white.svg': shiftOEWhiteSvg,
  'svg/Icons/16/shift-oe-gray.svg': shiftOEGraySvg,
  'svg/Icons/32/groups-gray.svg': groupsGray32Svg,
  'svg/Icons/32/location-gray.svg': locationGray32Svg,
  'svg/Icons/32/position-gray.svg': positionGray32Svg,
  'svg/Icons/32/tag-gray.svg': tagsGray32Svg,
  'svg/Icons/32/time-gray.svg': timeGray32Svg,
  'svg/Icons/32/events-gray.svg': eventsGray32Svg,
  'svg/UI/location-gray.svg': uiLocationGraySvg,
  'svg/UI/employee-gray.svg': uiEmployeeGraySvg,
  'svg/UI/status-gray.svg': uiStatusGraySvg,
  'svg/UI/position-gray.svg': positionGraySvg,
  'svg/UI/day-part.svg': dayPartSvg,
  'svg/Icons/16/exclamation.svg': exclamationSvg,
  'svg/UI/archived-conversations.svg': archivedConversationsSvg,
  'svg/UI/msg-edit.svg': msgEditSvg,
  'svg/UI/msg-trash.svg': msgTrashSvg,
  'svg/UI/arrow-right.svg': arrowRightSvg,
  'svg/Icons/32/state.svg': stateSvg,
  'svg/UI/edit-gray.svg': editSvg,
  /* eslint-enable key-spacing */
};

export default function imgToSvgDirective() {
  return {
    restrict: 'E',
    link($scope, $element, $attrs) {
      if (!$element.closest('button.btn-with-icon')[0] && !('imgToSvg' in $attrs)) {
        return;
      }

      if ($element[0].src) {
        replaceWithSvg($element[0].src);
      } else if ($attrs.ngSrc) {
        replaceWithSvg($attrs.ngSrc);
      }

      function replaceWithSvg(src) {
        const match = src.match(/assets\/(.+?\.svg)$/);

        if (!match) {
          return;
        }

        let mapKey = match[1];
        if (!__DEV__) {
          mapKey = mapKey.replace(/-[\w\d]{6}\.svg$/, '.svg');
        }

        if (SVG_MAP[mapKey]) {
          const svg = angular.element(SVG_MAP[mapKey]);
          svg.addClass('img');
          svg.addClass('img-replaced-by-svg');
          svg.addClass($element[0].className);
          $element.replaceWith(svg);
        } else if (!__TEST__) {
          console.warn(`No svg for "${mapKey}". It should be included it in SVG_MAP above`);
        }
      }
    },
  };
}

if (__TEST__) {
  Object.assign(imgToSvgDirective, { SVG_MAP });
}
